var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "comments clearfix" },
    [
      _c("div", { staticClass: "comments__top" }, [
        _c("h4", { staticClass: "comments__title txt--white" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.texts.reactions_main_title) +
              " \n            "
          ),
          _c("sup", [_vm._v("(" + _vm._s(_vm.comments.length) + ")")])
        ]),
        _vm._v(" "),
        _vm.commentState == 0
          ? _c(
              "span",
              {
                staticClass: "comments__add btn-ghost--white",
                on: {
                  click: function($event) {
                    return _vm.writeComment()
                  }
                }
              },
              [_vm._v("Reageren")]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.commentState == 0
        ? [
            _c(
              "div",
              {
                staticClass: "comments__comments",
                style: { height: _vm.commentsWrapHeight + "px" }
              },
              _vm._l(_vm.comments, function(comment, i) {
                return _c(
                  "div",
                  [
                    _vm.activeComments.indexOf(i) >= 0
                      ? _c("Comment", { attrs: { data: comment } })
                      : _vm._e()
                  ],
                  1
                )
              }),
              0
            ),
            _vm._v(" "),
            _vm.comments.length > _vm.commentsPerPage
              ? _c(
                  "div",
                  { staticClass: "comments__pagination" },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "comments__pagination-btn comments__pagination-btn--prev",
                        class: { disabled: _vm.activePage <= 0 },
                        on: { click: _vm.paginationPrev }
                      },
                      [_c("ArrowRight")],
                      1
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.pageNo, function(page, i) {
                      return _c(
                        "div",
                        {
                          staticClass:
                            "comments__pagination-btn comments__pagination-btn--number",
                          class: { active: i == _vm.activePage },
                          attrs: { bind: "pagination" + i },
                          on: {
                            click: function($event) {
                              return _vm.paginationN(i)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                " +
                              _vm._s(i + 1) +
                              "\n            "
                          )
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "comments__pagination-btn comments__pagination-btn--next",
                        class: { disabled: _vm.activePage >= _vm.pageNo - 1 },
                        on: { click: _vm.paginationNext }
                      },
                      [_c("ArrowRight")],
                      1
                    )
                  ],
                  2
                )
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.commentState == 1
        ? [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newName,
                  expression: "newName"
                }
              ],
              staticClass: "comments__input-name",
              attrs: {
                type: "text",
                placeholder: _vm.texts.reactions_name_input
              },
              domProps: { value: _vm.newName },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.newName = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newComment,
                  expression: "newComment"
                }
              ],
              staticClass: "comments__input-comment",
              attrs: {
                type: "textarea",
                maxlength: "400",
                placeholder: _vm.texts.reactions_input
              },
              domProps: { value: _vm.newComment },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.newComment = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c("p", { staticClass: "comments__rules" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.texts.reactions_subtitle) +
                  "\n            "
              ),
              _c(
                "a",
                { attrs: { href: _vm.texts.reactions_link, target: "_blank" } },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.texts.reactions_link_title) +
                      "\n            "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "comments__submit btn-solid--yellow",
                class: { active: _vm.newComment.length },
                on: {
                  click: function($event) {
                    return _vm.postComment()
                  }
                }
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.texts.reactions_send) +
                    "\n        "
                )
              ]
            )
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.commentState == 2
        ? _c("div", { staticClass: "comments__confirmation" }, [
            _c("h5", [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.texts.reactions_thanks_title) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.texts.reactions_thanks_text) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "btn-ghost--white mt-l mb-l",
                on: {
                  click: function($event) {
                    return _vm.setCommentState(0)
                  }
                }
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.texts.reactions_all) +
                    "\n        "
                )
              ]
            )
          ])
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }